import { IEntity } from "@interfaces/entity"

export class Pricing implements IEntity {
  id: number
  ownerUserId: string
  productId: string
  priceId: string
  
  name: string
  description: string
  price: number
  priceDc: number
  isPublic: boolean
  isArchived: boolean
  created: Date

  entityName = "Pricing"

  constructor(formValue?: Partial<Pricing>) {
    Object.assign(this, formValue)
  }

  updateValues(formValue: Partial<Pricing>) {
    Object.assign(this, formValue)
  }

  getPrimaryKey() {
    return this.id
  }
}
